// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2QAXn","colBig":"styles_colBig__MbzTH","colSmall":"styles_colSmall__ul5-W","shopifyNameWrapper":"styles_shopifyNameWrapper__1NYLc"};